import { Controller } from "@hotwired/stimulus";

// Client-side column sorting for the bank statement review table.
// Reads values from each row's <input> so it works on the editable form,
// and reorders <tr> elements only (Rails maps nested fields by hidden id,
// so row order does not affect saving).
export default class extends Controller {
  static targets = ["body"];

  sort(event) {
    const header = event.currentTarget;
    const index = Number(header.dataset.sortIndex);
    const type = header.dataset.sortType || "text";
    const dir = header.dataset.sortDir === "asc" ? "desc" : "asc";

    this.element.querySelectorAll("[data-sort-index]").forEach((other) => {
      if (other !== header) {
        delete other.dataset.sortDir;
        this.setIcon(other, null);
      }
    });
    header.dataset.sortDir = dir;
    this.setIcon(header, dir);

    const rows = Array.from(this.bodyTarget.querySelectorAll("tr[data-row]"));
    rows.sort((a, b) => {
      const av = this.value(a, index, type);
      const bv = this.value(b, index, type);
      let cmp;
      if (type === "number") {
        cmp = av - bv;
      } else {
        cmp = String(av).localeCompare(String(bv));
      }
      return dir === "asc" ? cmp : -cmp;
    });

    rows.forEach((row) => this.bodyTarget.appendChild(row));
  }

  value(row, index, type) {
    const cell = row.children[index];
    const input = cell ? cell.querySelector("input") : null;
    const raw = (input ? input.value : cell ? cell.textContent : "").trim();
    return type === "number" ? parseFloat(raw.replace(/,/g, "")) || 0 : raw;
  }

  setIcon(header, dir) {
    const icon = header.querySelector("[data-sort-icon]");
    if (!icon) return;
    // Plain text arrows: avoids FontAwesome's SVG auto-replacement, whose
    // className is read-only and throws when assigned.
    icon.textContent = dir === "asc" ? " ↑" : dir === "desc" ? " ↓" : " ↕";
  }
}
